export default "__VITE_ASSET__CCPtF_jg__"